import template from './admin-hotel-merge.html';

AdminHotelMerge.DIRECTIVE_NAME = 'ktAdminHotelMerge';
export default function AdminHotelMerge() {
    return {
        restrict: 'A',
        controller: AdminHotelMergeController,
        controllerAs: 'adminHotelMergeCtrl',
        template,
        bindToController: true,
        link,
    };

    function link($scope, $elem, $attrs, adminHotelMergeCtrl) {
        adminHotelMergeCtrl.$onInit();
    }
}

export function AdminHotelMergeController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-merge/admin-hotel-merge-component.js